import React from "react";

function PhoneSignup() {
  return <div>
    
  </div>;
}

export default PhoneSignup;
